import React from "react";
import ModalCard from "./ModalCard";

export default function GuestModeModal({ onContinue, onClose, dismissible = false }) {
  return (
    <ModalCard
      title="Pounce! guest mode"
      onPrimary={onContinue}
      primaryText="Continue"
      dismissible={dismissible}
      onClose={onClose}
      accentBorder="#929292"
    >
      <p 
        style={{
          letterSpacing: "0.5px",   // adds slight spacing between letters
          lineHeight: "150%",       // more vertical breathing room
        }}
      >
        You are using POUNCE in Guest Mode. None of your entries will be stored
        or used in the POUNCE research project. Enjoy watching puppies!
      </p>
    </ModalCard>
  );
}
